import React from 'react'
import { Dropdown, Menu } from 'antd'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import { logoutAuth } from '../../common/request'

//withRouter一定要写在前面，不然路由变化不会反映到props中去
export class HeaderBar extends React.Component {
  state = {
    avatar: require('./img/04.jpg')
  }

  handleLogout = async () => {
    try {
      await logoutAuth()
    } catch (e) {
      // 即使后端注销失败，也清理前端 token，避免用户无法退出。
    } finally {
      this.props.appStore.toggleLogin(false)
      this.props.history.replace('/login')
    }
  }

  render () {
    const {avatar} = this.state
    const {appStore} = this.props
    const loginUser = appStore.loginUser || {}
    const displayName = loginUser.name || loginUser.email || '管理员'
    const picture = loginUser.picture || avatar
    const menu = (
      <Menu className='account-menu'>
        <Menu.Item key='profile' disabled>
          <div className='account-menu-profile'>
            <img src={picture} alt=''/>
            <div>
              <div className='account-menu-name'>{displayName}</div>
              {loginUser.email && <div className='account-menu-email'>{loginUser.email}</div>}
            </div>
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key='logout' onClick={this.handleLogout} className='account-menu-logout'>
          退出登录
        </Menu.Item>
      </Menu>
    )

    return (
      <div id='headerbar'>
        <Dropdown overlay={menu} placement='bottomRight' trigger={['click']}>
          <button type='button' className='login-avatar' title={displayName}>
            <img src={picture} alt={displayName}/>
          </button>
        </Dropdown>
      </div>
    )
  }
}

export default withRouter(inject('appStore')(observer(HeaderBar)))



// WEBPACK FOOTER //
// ./src/components/HeaderBar/index.js